// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"078c59ce7c3f4c91","931":"8fe4b81950b43d73"}[chunkId] + ".css";
};